"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({app}) {
        this.state = {
            extensionId: false,
            processing: false,
            showDialog: false,
            alert: false
        };
        this.isInstalled(app.name);
    },
    isInstalled: async function (name) {
        try {
            const {error, message, results} = await Request(`/extension/search?query=${ name }`);
            if (error)
                throw new Error(message);
            if (results && results.length)
                this.state.extensionId = results[0].extensionId;
        } catch (error) {
            console.log('Error Searching App: ', error);
        }
    },
    onInstall: async function () {
        try {
            this.state.processing = true;
            const extensionId = await window.Extensions.install(this.input.app);
            if (!extensionId)
                throw new Error('Unexpected Error Occured');
            this.state.processing = false;
            this.state.extensionId = extensionId;
        } catch (error) {
            this.state.processing = false;
            this.state.alert = error;
        }
    },
    onUninstall: async function () {
        async function uninstall() {
            this.state.processing = true;
            if (await window.Extensions.uninstall(this.state.extensionId)) {
                this.state.processing = false;
                this.state.extensionId = false;
                this.emit('remove');
            } else {
                this.state.processing = false;
                this.state.alert = error;
            }
        }
        if (this.input.active) {
            this.emit('dialog', {
                type: 'warning',
                message: 'Uninstalling this app will also delete all its configurations. Are you sure?',
                actions: {
                    yes: {
                        label: 'Continue',
                        fn: uninstall.bind(this)
                    },
                    no: {
                        label: 'Cancel',
                        active: true
                    }
                }
            });
            return;
        }
        uninstall.bind(this)();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LiveSessions/Admin/Providers/components/Provider.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Favicon_template = require("../../../../../components/Favicon.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Favicon_tag = marko_loadTag(Favicon_template),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Preloader_template = require("../../../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    marko_attrs0 = {
        "class": "border round"
      },
    marko_attrs1 = {
        "class": "border-top px-1 py-50 text-right"
      },
    marko_attrs2 = {
        "class": "font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ab0b6d"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "text-ellipsis-2 text-muted"
      },
    marko_attrs4 = {
        "class": "btn btn-secondary btn-sm"
      },
    marko_attrs5 = {
        "class": "btn btn-secondary btn-sm m-25"
      },
    marko_attrs6 = {
        "class": "btn btn-primary btn-sm m-25"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-sm m-25"
      };

function shouldSetup( resource ){
  return !!( Array.isArray( resource.requirements ) && resource.requirements.length )
};

function shouldConfigure({ resource, configs }){
  return !!( Array.isArray( resource.requirements )
            && typeof configs == 'object'
            && resource.requirements.filter( each => { return configs.hasOwnProperty( each ) } ).length )
};

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "d-flex align-items-center p-1",
      col: [
          {
              class: ("col-" + (input.active ? 3 : 4)) + " d-flex text-center",
              renderBody: function(out) {
                Favicon_tag(marko_assign({
                    width: 42
                  }, input.app, {
                    class: "font-medium-1"
                  }), out, __component, "3");
              }
            },
          {
              renderBody: function(out) {
                out.e("span", marko_attrs2, "5", component, 1)
                  .t(input.app.name, component);

                if (input.active) {
                  Locale_tag({
                      text: "Active",
                      class: "text-success font-small-2 float-right px-50"
                    }, out, __component, "6");

                  out.n(marko_node0, component);
                }

                out.be("div", null, "8", component);

                if (state.alert) {
                  out.be("div", null, "9", component);

                  Locale_tag({
                      text: state.alert,
                      class: "font-small-2 text-warning"
                    }, out, __component, "10");

                  out.ee();
                } else {
                  if (input.active) {
                    out.e("p", marko_attrs3, "11", component, 1)
                      .t(input.app.description, component);
                  } else {
                    Locale_tag({
                        text: "Install to setup",
                        class: "font-small-2 text-muted"
                      }, out, __component, "12");
                  }
                }

                out.ee();
              }
            }
        ]
    }, out, __component, "1");

  out.be("div", marko_attrs1, "13", component);

  if (!state.extensionId) {
    out.be("button", marko_attrs4, "14", component, null, 0, {
        onclick: __component.d("click", "onInstall", false)
      });

    Locale_tag({
        text: "Install"
      }, out, __component, "15");

    Preloader_tag({
        active: state.processing
      }, out, __component, "16");

    out.ee();
  } else {
    out.be("button", marko_attrs5, "17", component, null, 0, {
        onclick: __component.d("click", "onUninstall", false)
      });

    Locale_tag({
        text: "Uninstall"
      }, out, __component, "18");

    Preloader_tag({
        active: state.processing
      }, out, __component, "19");

    out.ee();

    if (shouldConfigure(input.app)) {
      out.be("button", marko_attrs6, "20", component, null, 0, {
          onclick: __component.d("click", () => component.emit('configure', { ...(input.app), id: state.extensionId } ), false)
        });

      Locale_tag({
          text: "Configure"
        }, out, __component, "21");

      out.ee();
    } else if (shouldSetup(input.app.resource)) {
      out.be("button", marko_attrs7, "22", component, null, 0, {
          onclick: __component.d("click", () => component.emit('setup', { ...(input.app), id: state.extensionId } ), false)
        });

      Locale_tag({
          text: "Setup"
        }, out, __component, "23");

      out.ee();
    }
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
